var React = require('react');

function Light (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.00033 12H23.4863","stroke":"#6B4E9F","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.9863 23L1.34333 12.751C1.12808 12.5612 1.00477 12.288 1.00477 12.001C1.00477 11.714 1.12808 11.4408 1.34333 11.251L12.9863 1","stroke":"#6B4E9F","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Light.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Light;

Light.default = Light;
